import { render, staticRenderFns } from "./CreateIdentityDlg.vue?vue&type=template&id=d745fa96&"
import script from "./CreateIdentityDlg.vue?vue&type=script&lang=js&"
export * from "./CreateIdentityDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports